var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phases"},[(_vm.content)?_c('div',{staticClass:"phases__content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),_c('ul',{staticClass:"phases__items"},_vm._l((_vm.value),function(item,index){return _c('li',{key:index,staticClass:"phases__item",class:{
        'phases__item--active': item.current,
        'phases__item--check': _vm.check(index),
      }},[_c('span',{staticClass:"phases__item-content"},[_vm._v(_vm._s(item.label))]),_c('strong',{staticClass:"phases__item-status"},[_vm._v(" "+_vm._s(item.content)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }